import React, { useState } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import { messages } from 'commons/js/messages'
import Container from './Container'
import * as themes from 'commons/js/theme'
import { EPProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'
import Portal from './components/Portal'

const getTheme = (theme) => themes[theme] || themes['maggie']

const App = ({town, theme, brandImage, brandImageMobile, brandId, bulletinNumber}) => {
    const [ townId, setTown ] = useState(town)
    return <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
        <EPProvider theme={getTheme(theme)} {...convertConstantToEPProviderFormat()}>
            <Container brandId={brandId} townId={townId} theme={theme} brandImageMobile={brandImageMobile} brandImage={brandImage}>
                <Router>
                    <Route render={() => <Portal onChangeTown={setTown} brandId={brandId} town={town} bulletinNumber={bulletinNumber} />} />
                </Router>
            </Container>
        </EPProvider>
    </IntlProvider>
}
App.propTypes = {
    town: PropTypes.number,
    theme: PropTypes.string.isRequired,
    brandImage: PropTypes.string.isRequired,
    brandImageMobile: PropTypes.string.isRequired,
    brandId: PropTypes.number.isRequired,
    bulletinNumber: PropTypes.any,
}

export default hot(App)
